import React from 'react';
import { Box } from './Box';
import { BoxButton } from './BoxButton';
import { BoxSlider } from './BoxSlider';
import { BoxToggle } from './BoxToggle';
import { ExtraToggle } from './ExtraToggle';

import { Banner } from './Banner';
import './pricing.scss';

const PrincingComponent = ({ children }: any) => (
  <div className="Pricing">{children}</div>
);

export const Pricing = Object.assign(PrincingComponent, {
  Banner,
  BoxToggle,
  BoxSlider,
  Box,
  ExtraToggle,
  BoxButton,
});
